export default __webpack_public_path__ + "static/media/IMG_2026.acecf05d.png";